module.exports = __webpack_public_path__ + "img/tab_03.9cedfc3a.jpg";